<template>
  <ul :class="[{ 'm-edition-asset-contents-list-child': isChild }, 'm-edition-asset-contents-list']">
    <li :class="[{ 'm-edition-asset-contents-list-item-drag': !disabledDragg }, 'm-edition-asset-contents-list-item']">
      <div :class="!disabledSelected && isCurrentNode
        ? 'm-edition-asset-contents-list-item-data m-edition-asset-contents-list-item-data-current'
        : 'm-edition-asset-contents-list-item-data'"
      >
        <a
          class="m-edition-asset-contents-list-item-data-name"
          href="#"
          @click.prevent="toggleChildren"
        >
          <i
            :id="`node-icon-circle-${nodo.id}`"
            class="fas fa-circle-notch fa-spin node-icon-loading"
          >
          </i>
          <i
            :id="`node-icon-caret-${nodo.id}`"
            :class="showChildren && nodo.children.length ? 'fas fa-caret-down' : 'fas fa-caret-right'"
          >
          </i>
          <span :class="nodeStateClass">
            {{ nodo.nombre }}
            <small v-if="nodo.children.length">
              ({{ nodo.children.length }} {{ $t('mEditionAssetContentsTreeNodes.subcontents') }})
            </small>
          </span>
        </a>
        <div :class="`m-edition-asset-contents-list-item-data-actions-${nodeActionsClass}`">
          <MoleculeEditionAssetContentsTreeNodeActions
            :is="moleculeNodeActions"
            :contenido="contenido"
            :element="element"
            :info="info"
            :level="level"
            :nodo="nodo"
            :parent="parent"
            @emitAction="emitAction"
          />
        </div>
      </div>
      <draggable
        v-model="nodo.children"
        :disabled="disabledDragg"
        ghost-class="m-edition-asset-contents-list-item-drag"
        group="m-edition-asset-contents-list"
        pull="false"
        scroll="true"
        @change="emitAction"
      >
        <transition-group
          name="a-transtion-slide"
          tag="li"
        >
          <MoleculeEditionAssetContentsTreeNode
            v-show="showChildren"
            v-for="child in nodo.children"
            :key="child.id"
            :contenido="contenido"
            :disabledDragg="disabledDragg"
            :disabledSelected="disabledSelected"
            :element="element"
            :info="info"
            :is-child="true"
            :level="level + 1"
            :nodo="child"
            :node-actions="nodeActions"
            :node-actions-class="nodeActionsClass"
            :parent="nodo"
            @emitAction="emitAction"
          />
        </transition-group>
      </draggable>
    </li>
  </ul>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MoleculeEditionAssetContentsTreeNode',

  components: {
    draggable
  },

  props: {
    contenido: Object,

    disabledDragg: {
      type: Boolean,
      default: true
    },

    disabledSelected: {
      type: Boolean,
      default: true
    },

    element: Object,

    info: {
      type: Object,
      default: () => ({})
    },

    isChild: Boolean,

    level: {
      type: Number,
      default: 0
    },

    nodo: Object,
    nodeActions: String,
    nodeActionsClass: String,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      moleculeNodeActions: '',
      showChildren: true
    }
  },

  computed: {
    isCurrentNode () {
      let selectedNode = this.$store.getters.getAssetSelectedNode
      return Object.keys(selectedNode).length
        ? this.nodo.id === this.$store.getters.getAssetSelectedNode.id
        : false
    },

    nodeStateClass () {
      // if (Object.values(this.info).length && this.info.nodosActivosInscripcion !== undefined) {
      //   let nodeState = this.info.nodosActivosInscripcion.find(nodo => nodo.nodo === this.nodo.id)
      //   return nodeState !== undefined
      //     ? nodeState.visto
      //       ? 'text-color-info'
      //       : 'text-color-success'
      //     : 'text-color-black-65'
      // } else if (Object.values(this.info).length && this.info.nodosActivos !== undefined) {
      //   let nodeDay = this.info.nodosActivos.nodos.find(anodo => anodo.nodo === this.nodo.id).dia
      //   return nodeDay === -1
      //     ? 'text-color-black-65'
      //     : 'text-color-success'
      // } else {
      //   return ''
      // }
      return ''
    }
  },

  watch: {
    nodeActions: {

      handler () {
        this.moleculeNodeActions = () => import(`@/components/molecules/MoleculeEditionAssetContentsTreeNode${this.nodeActions}`)
      },

      immediate: true
    }
  },

  created () {
    // this.showChildren = this.nodeActions === 'Questions'
  },

  methods: {
    emitAction (params) {
      this.$emit('emitAction', params)
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    }
  }
}
</script>
